export default "/assets/images/mila-room-showcase-sm-02.webp?3003ebd5db1f20fd6b10496cbaa8eea1";